<template>
	<component :is="offeringPageType" :is-iframe="isIframe" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { Component as ComponentType } from 'vue';
import { useRoute } from 'vue-router';
import ViewFundriseEreitFundDetails from '@components/offering-details/view-fundrise-ereit-fund-details.vue';
import ViewInnovationFundDetails from '@components/offering-details/view-innovation-fund-details.vue';
import ViewIntervalFundDetails from '@components/offering-details/view-interval-fund-details.vue';
import ViewReitDetails from '@components/offering-details/view-reit-details.vue';
import { fundriseEreitId, growthTechReitId, intervalFundReitIds } from '@constants/reit';

interface Props {
	isIframe?: boolean;
}

withDefaults(defineProps<Props>(), {
	isIframe: false
});

const route = useRoute();

const offeringId = computed((): string => route.params.offeringId as string);

const offeringPageType = computed((): ComponentType => {
	if (offeringId.value === growthTechReitId) {
		return ViewInnovationFundDetails;
	} else if (offeringId.value === fundriseEreitId) {
		return ViewFundriseEreitFundDetails;
	} else if (intervalFundReitIds.includes(offeringId.value)) {
		return ViewIntervalFundDetails;
	} else {
		return ViewReitDetails;
	}
});
</script>
